module.exports = __webpack_public_path__ + "static/media/W320.b20773a6.png";